import { Types } from '@fiverr-private/theme';
import { TabContextType } from '../../types';
import { isSegmentedControlVariant } from '../../helpers';

const MARGIN_ZERO = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
};

export const getStylingProps = (
    variant: TabContextType['variant'],
    placement: TabContextType['placement'],
    orientation: Types.Box['aria-orientation']
): Types.ContainerProps => ({
    ...(variant === 'default' && {
        backgroundColor: 'grey_1200',
        ...MARGIN_ZERO,
        [placement]: undefined,
        [orientation === 'horizontal' ? 'height' : 'width']: '2px',
    }),
    ...(isSegmentedControlVariant(variant) && {
        backgroundColor: 'white',
        ...MARGIN_ZERO,
        [orientation === 'horizontal' ? 'top' : 'left']: '8px',
        borderRadius: variant === 'segmentedControlRounded' ? 'circle' : 'sm',
        boxShadow: 'z2',
    }),
});
